export const PRIVILEGES = {
  STUDENT_CREATE: 'student:c',
  STUDENT_EDIT: 'student:u',
  STUDENT_VIEW: 'student:r',
  STUDENT_PROFILE_VIEW1: 'student-p:r',
  STUDENT_PROFILE_VIEW2: 'student:profile:r',
  STUDENT_DELETE: 'student:d',
  STUDENT_BULK_CREATE: 'bulk:student:c',
  STUDENT_DELETE_DOCUMENT: 'student:dd',

  STUDENT_INVOICE_VIEW: 'student:invoice:profile:r',
  STUDENT_INVOICE_VIEW2: 'student-inv:r',
  STUDENT_INVOICE_UPDATE: 'student-inv:u',
  STUDENT_INVOICE_NOTIFICATION: 'student-inv:n',

  STUDENT_PAYMENT_VIEW: 'student-pay:r',
  STUDENT_PAYMENT_RECEIVE1: 'student:payment:receive',
  STUDENT_PAYMENT_RECEIVE2: 'student-pay:u',
  STUDENT_RECEIPT_VIEW: 'student:receipt:r',
  STUDENT_RECEIPT_VIEW2: 'student-pay:r',
  STUDENT_DISCOUNT_CREATE: 'student:discount:c',
  STUDENT_DISCOUNT_MANAGE: 'student-dsc:u',

  INVOICE_TEMPLATE_ASSIGN: 'invoice:template:assign',
  INVOICE_TEMPLATE_CREATE: 'invoice:template:c',
  INVOICE_TEMPLATE_VIEW3: 'invoice:template:r',
  INVOICE_TEMPLATE_EDIT: 'student:invoice:u',
  INVOICE_TEMPLATE_VIEW: 'student:invoice:r',
  INVOICE_TEMPLATE_DELETE: 'student:invoice:d',

  INVOICE_TEMPLATE_ASSIGN2: 'fees-c-it:a',
  INVOICE_TEMPLATE_CREATE2: 'fees-c-it:c',
  INVOICE_TEMPLATE_EDIT2: 'fees-c-it:u',
  INVOICE_TEMPLATE_VIEW2: 'fees-c-it:r',

  FEES_VIEW: 'fees:r',
  FEES_TRANSACTION_LOG_VIEW: 'fees:tl',
  FEES_SEND_NOTIFICATION: 'fees:n',

  DASHBOARD_SUMMARY: 'summary:dashboard',
  DASHBOARD_ATTENDANCE: 'attendance:dashboard',
  DASHBOARD_PERFORMANCE: 'performance:dashboard',
  DASHBOARD_FEES: 'financial:dashboard',

  PAYABLE_ITEM_CREATE: 'payable:item:c',
  PAYABLE_ITEM_EDIT: 'payable:item:u',
  PAYABLE_ITEM_VIEW: 'payable:item:r',
  PAYABLE_ITEM_DELETE: 'payable:item:d',

  BANK_CREATE: 'bank:c',
  BANK_UPDATE: 'bank:u',
  BANK_DELETE: 'bank:d',

  SUBJECTS_VIEW: 'subjects:r',
  SUBJECTS_PROFILE_VIEW: 'subjects-p:r',
  SUBJECTS_PROFILE_UPDATE: 'subjects-p:u',
  ASSIGN_SUBJECT_TEACHER: 'subjects:st',

  HEAD_TEACHER_COMMENT: 'head-teacher:x',

  ARM_CREATE: 'arm:c',
  ARM_EDIT: 'arm:u',
  ARM_DELETE: 'arm:d',

  ADMIN_PROFILE_VIEW: 'admin:profile:r',

  PARENT_RESET_PASSWORD: 'parent:rp',
  PARENT_DELETE: 'parent:d',
  PARENT_EDIT: 'parent:u',
  PARENT_VIEW: 'parent:r',
  PARENT_CREATE: 'parent:c',
  PARENT_VIEW_PROFILE: 'parent-p:r',

  STAFF_CREATE: 'staff:c',
  STAFF_DELETE: 'staff:d',
  STAFF_PROFILE_EDIT: 'staff:pe',
  STAFF_RESET_PASSWORD: 'staff:rp',
  STAFF_PROFILE_VIEW1: 'staff:profile:r',
  STAFF_PROFILE_VIEW2: 'staff-p:r',
  STAFF_VIEW: 'staff:r',
  STAFF_BULK_CREATE: 'bulk:staff:c',
  STAFF_EDIT: 'staff:u',
  STAFF_DELETE_DOCUMENT: 'staff:dd',

  APPROVE_OR_DECLINE_REQUEST: 'profiles:request:manage',

  STUDENT_RESULT_VIEW: 'results:r',
  RESULT_APPROVE: 'results:ap',
  BROADSHEET_APRROVE_RESULT: 'broadsheet:ap',
  BROADSHEET_VIEW: 'broadsheet:r',

  SKILLS_VIEW: 'skills:r',
  TRAITS_VIEW: 'traits:r',
  CLASSES_VIEW: 'classes:r',
  CLASSES_ASSIGN_FORM_TEACHER: 'classes:ft',
  CLASS_UPDATE: 'classes:u',

  CLASS_LEVEL_VIEW: 'class:level:r',
  CLASS_LEVEL_CREATE: 'class:level:c',
  CLASS_LEVEL_EDIT: 'class:level:u',
  CLASS_LEVEL_DELETE: 'class:level:d',

  CALENDAR_VIEW: 'calendar:activity:r',
  CALENDAR_CREATE: 'calendar:activity:c',
  CALENDAR_EDIT: 'calendar:activity:u',
  CALENDAR_DELETE: 'calendar:activity:d',

  SESSION_VIEW: 'session:r',
  SESSION_CREATE: 'session:c',
  SESSION_EDIT: 'session:u',
  SESSION_DELETE: 'session:d',

  MANAGE_SETTINGS: 'settings:g',
  FEES_SETTINGS: 'settings:f',

  CONFIG_PERFORMANCE: 'config:performance',
  CONFIG_REPORT_TEMPLATE: 'config:report-template',
  CONFIG_ATTENDANCE: 'config:attendance',
  CONFIG_SMS: 'sms:config',

  ID_SETUP: 'id:setup',
  ID_DISTRIBUTION: 'id:distribution',

  SUBJECT_CONFIG_VIEW: 'subject:config:r',
  SUBJECT_CONFIG_CREATE: 'subject:config:c',
  SUBJECT_CONFIG_EDIT: 'subject:config:u',
  SUBJECT_CONFIG_DELETE: 'subject:config:d',
  SUBJECT_ASSIGN_LEVEL: 'subject:config:al',
  SUBJECT_GROUP_CONFIG_VIEW: 'subject-g:config:r',
  SUBJECT_GROUP_CONFIG_CREATE: 'subject-g:config:c',
  SUBJECT_GROUP_CONFIG_EDIT: 'subject-g:config:u',
  SUBJECT_GROUP_CONFIG_DELETE: 'subject-g:config:d',

  ASSET_CATEGORY_CREATE: 'asset:category:c',
  ASSET_CATEGORY_VIEW: 'asset:category:r',
  ASSET_CATEGORY_UPDATE: 'asset:category:u',
  ASSET_CATEGORY_DELETE: 'asset:category:d',

  EXPENSE_CATEGORY_CREATE: 'expense:category:c',
  EXPENSE_CATEGORY_VIEW: 'expense:category:r',
  EXPENSE_CATEGORY_UPDATE: 'expense:category:u',
  EXPENSE_CATEGORY_DELETE: 'expense:category:d',

  EXPENSE_ITEM_CREATE: 'expense:item:c',
  EXPENSE_ITEM_VIEW: 'expense:item:r',
  EXPENSE_ITEM_UPDATE: 'expense:item:u',
  EXPENSE_ITEM_DELETE: 'expense:item:d',

  EXPENSES_CREATE: 'expenses:c',
  EXPENSES_VIEW: 'expenses:r',

  INVENTORY_CATEGORY_CREATE: 'inventory:category:c',
  INVENTORY_CATEGORY_VIEW: 'inventory:category:r',
  INVENTORY_CATEGORY_UPDATE: 'inventory:category:u',
  INVENTORY_CATEGORY_DELETE: 'inventory:category:d',

  INVENTORY_ITEM_CREATE: 'inventory:item:c',
  INVENTORY_ITEM_VIEW: 'inventory:item:r',
  INVENTORY_ITEM_UPDATE: 'inventory:item:u',
  INVENTORY_ITEM_DELETE: 'inventory:item:d',

  MERCHANT_CREATE: 'merchant:c',
  MERCHANT_VIEW: 'merchant:r',
  MERCHANT_UPDATE: 'merchant:u',
  MERCHANT_DELETE: 'merchant:d',

  INVENTORY_VIEW: 'inventory:r',
  INVENTORY_MANAGE: 'inventory:u',

  MESSAGE_NOTIFICATION_CREATE: 'message:c',
  MESSAGE_NOTIFICATION_UPDATE: 'message:u',
  MESSAGE_NOTIFCATION_DELETE: 'message:d',

  CBT_EXAM_CREATE: 'cbt:c',
  CBT_EXAM_VIEW: 'cbt:r',
  CBT_EXAM_EDIT: 'cbt:u',
  CBT_EXAM_DELETE: 'cbt:d',
} as const;

export type Privilege = (typeof PRIVILEGES)[keyof typeof PRIVILEGES];
